import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { confirmSignUp, resendSignUpCode } from 'aws-amplify/auth';
// import { useAuthContext } from '../../../contexts/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Container, Form, InputGroup, Modal } from 'react-bootstrap';
import CustomModal from '../../../components/Modals/CustomModal';
import { useTranslation } from 'react-i18next';
import { Toast, ToastContainer } from 'react-bootstrap';


// Cognito username = email
type ConfirmEmailData = {
  username: string;
  confirmationCode: string;
};

const ConfirmEmailScreen = () => {
  // I18N
  const { t } = useTranslation();
  // NAVIGATION
  const location = useLocation();
  const navigate = useNavigate();
  // TOAST
  const [showToast, setShowToast] = useState(false);
  const [toastStatus, setToastStatus] = useState("");
  const [toastTitle, setToastTitle] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [footerModal, setFooterModal] = useState(true);
  // VALIDATION
  const [loading, setLoading] = useState(false);

  const {register, control, handleSubmit, watch, reset} = useForm<ConfirmEmailData>();

  // useEffect(() => {
  //   if (showWarningModal) {
  //     <WarningModal open={showWarningModal}/>
  //   }
  // }, [showWarningModal]);

  useEffect(() => {
    if (location.state?.toastMessage) {
      setToastStatus(location.state.status);
      setToastTitle(location.state.title);
      setToastMessage(location.state.toastMessage);
      setShowToast(true);

      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  useEffect(() => {
    document.title = t('title.confirmEmail');
  }, []);

  const onConfirmPressed = async ({username, confirmationCode}: ConfirmEmailData) => {
    if (loading) {
      return;
    };
    setLoading(true);
    try {
      const { isSignUpComplete, nextStep } = await confirmSignUp({username, confirmationCode});
      setFooterModal(false);
      setContentModal(<><Modal.Header closeButton>
        <Modal.Title>{t('signup.EmailConfirmSuccessTitle')}</Modal.Title>
            </Modal.Header>
      
            <Modal.Body>
              <p>{t('signup.EmailConfirmSuccessMessage')}</p>
            </Modal.Body>
            
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {setShowCustomModal(false); setFooterModal(true); navigate('/',{ state: { status: "bg-success", title: t('toast.firstConnectTitle'), toastMessage: t('toast.firstConnect')}});}}>
                  {t('punch.close')}
                </Button>
            </Modal.Footer>
            </>
            
          );
      setShowCustomModal(true);
      // navigate('/');
    } catch (error) {
      setFooterModal(true);
      setContentModal(<><Modal.Header closeButton>
        <Modal.Title>{t('signup.EmailConfirmErrorTitle')}</Modal.Title>
            </Modal.Header>
      
            <Modal.Body>
              <p>{(error as Error).message}.</p>
            </Modal.Body></>);
      setShowCustomModal(true);
    } finally {
      setLoading(false);
      reset();
    };
  };

  const onSignUpPress = () => {
    navigate('/signIn');
  };

  const onResendPress = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const username = watch("username");
    if (!username) {
      setContentModal(<><Modal.Header closeButton>
        <Modal.Title>{t('signup.warning')}</Modal.Title>
            </Modal.Header>
      
            <Modal.Body>
              <p>{t('signup.enterEmail')}</p>
            </Modal.Body></>);
      setShowCustomModal(true);
      return;
    }
    
    try {
      await resendSignUpCode({username: username});
      setContentModal(<><Modal.Header closeButton>
        <Modal.Title>{t('signup.codeSended')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>{t('signup.watchMailbox')}</p>
            </Modal.Body></>);
      setShowCustomModal(true);
    } catch (error) {
      console.log('error to resend code: ', error);
      setContentModal(<><Modal.Header closeButton>
        <Modal.Title>{t('signup.codeError')}</Modal.Title>
            </Modal.Header>
      
            <Modal.Body>
              <p>{(error as Error).message}.</p>
            </Modal.Body></>);
      setShowCustomModal(true);
      // alert("Error resending code: " + (error as Error).message);
    };
  };

  const hideModal = () => {
    setShowCustomModal(false);
  };

  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        isFooter={footerModal}
        // animation={true}
      />

      <ToastContainer className="p-3 toastTop">
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide className={`${toastStatus}`}>
          { toastTitle != "" &&
            <Toast.Header className={`text-center ${toastStatus}`}>
              <strong className="mx-auto text-white-50 text-center">{toastTitle}</strong>
            </Toast.Header>
          }
          <Toast.Body className="text-center"><strong className="mx-auto text-white text-center">{toastMessage}</strong></Toast.Body>
        </Toast>
      </ToastContainer>

      <Form className="register-form">
        <h2 className="text-center">{t('signup.confirmEmailForm')}</h2>
        <Container>
          <InputGroup>
            <Form.Control
              placeholder="Email"
              aria-label="Username"
              // aria-describedby="basic-addon1"
              className="me-lg-2"
              {...register("username")} 
              name="username"
            />
          </InputGroup>

          <InputGroup>
            <Form.Control
              placeholder="Enter your confirmation code"
              aria-label="Username"
              aria-describedby="basic-addon1"
              className="me-lg-2"
              {...register("confirmationCode")} 
              name="confirmationCode"
            />
          </InputGroup>
          <InputGroup>
            <Button type="submit" onClick={handleSubmit(onConfirmPressed)} disabled={loading}>{ loading ? t('signup.loading') : t('signup.confirmEmail')}</Button>
          </InputGroup>

        </Container>
        <Container>
          <Button type="button" onClick={onResendPress} className="me-4" disabled={loading}>{ loading ? t('signup.loading') : t('signup.resendCode')}</Button>
          {/* <Button type="button" onClick={onSignUpPress}>Back to Sign in</Button> */}
        </Container>
      </Form>
    </>    
  );
};

export default ConfirmEmailScreen;
